import { render, staticRenderFns } from "./ReadingsSignature.vue?vue&type=template&id=7510c21a"
import script from "./ReadingsSignature.vue?vue&type=script&lang=js"
export * from "./ReadingsSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports